import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { LoggingService } from '@domgen/dgx-fe-logging';
import { combineLatest, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { RegistrationFacade } from '../../+state/registration.facade';

export const hasQuoteResponseNoContentGuard: CanActivateFn = (
  route
): Observable<boolean> => {
  const registrationFacade = inject(RegistrationFacade);
  const loggingService = inject(LoggingService);
  const router = inject(Router);

  loggingService.debug('hasQuoteResponseNoContentGuard', 'Start');
  const redirectTo: string = route.data?.['redirectTo'] ?? '/';

  return combineLatest([
    registrationFacade.isQuoteResponseSuccess$,
    registrationFacade.isQuoteResponseNoContent$,
  ]).pipe(
    first(),
    map(([isQuoteResponseSuccess, isQuoteResponseNoContent]) => {
      if (!isQuoteResponseSuccess && !isQuoteResponseNoContent) {
        router.navigate([redirectTo], {
          queryParams: route.queryParams,
          replaceUrl: true,
        });
        return false;
      }

      loggingService.debug('hasQuoteResponseNoContentGuard', 'Success');
      return true;
    })
  );
};
